import { ChangeEventHandler, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ItemCategoryForm from "../../components/admin/ItemCategoryForm";
import AdminLayout from "../../components/custom/layouts/AdminLayout";
import { nanoid } from "@reduxjs/toolkit";
import Modal from "../../components/Modal";
import Option from "../../components/Option";
import  {
  Tbody,
  Thead,
} from "../../components/custom/components/AdminTable";
import { ToastTypes, useToast } from "../../components/toast/ToastProvider";
import { FormType, FormTypeList } from "../../config";
import {
  ItemCategoryType,
  deleteItemCategory,
  fetchItemCategory,
} from "../../redux/actions/itemcategory";
import { ItemSubcategoryType } from "../../redux/actions/itemsubcategory";
import { AppDispatch, StoreState } from "../../redux/store";
import DeleteConfirmationForm from "../../components/admin/DeleteConfirmationForm";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AdminTable2 from "../../components/custom/components/AdminTable2";
import { AuthAdminType } from "../../redux/actions/authAdminActions";
import { AdminLog } from "../../config/common";
import { FormInput } from "../../components/custom/components";
import { PortfolioType } from "../../redux/actions/portfolioActions";
import { fetchDepartment, ItemDepartmentType } from "../../redux/actions/itemdepartment";

type HandleDelete = (value: ItemCategoryType) => void;

const ItemCategory = () => {
  const toast = useToast();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const pageName = useLocation()
  const authAdmin = useSelector<StoreState, AuthAdminType | null>(
    (state) => state.authAdmin
  );
  const adminAuthendicated =
  typeof authAdmin?.["auth-token"] === "string" &&
  authAdmin?.["auth-token"] !== undefined &&
  authAdmin?.["auth-token"] !== "";
  const departmentList = useSelector<StoreState, Array<ItemDepartmentType>>(
    (state) => state.department
  );
  const ItemCategoryList = useSelector<StoreState, Array<ItemCategoryType>>(
    (state) => state.itemcategory
  );
  const ItemSubcategoryList = useSelector<StoreState, Array<ItemSubcategoryType>>(
    (state) => state.itemsubcategory
  );
  const portfolioList = useSelector<StoreState, Array<PortfolioType>>(
    (state) => state.portfolio
  );
  // const filteredPortfolio = portfolioList.filter((a) => a.businessmodel !== 1);
  const [portfolioId, setportfolioId] = useState<string>("");
  const [portfolioIdError, setportfolioIdError] = useState<string>("");
  const [showForm, setShowForm] = useState<boolean>(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
  const [formType, setFormType] = useState<FormType>(FormTypeList.ADD);
  const [editData, setEditData] = useState<ItemCategoryType>();
  const [deleteData, setDeleteData] = useState<ItemCategoryType>();
  const [showViewForm, setShowViewForm] = useState<boolean>(false);
  const [disableDelete, setDisableDelete] = useState<boolean>(false);
  const [id, setId] = useState<number>();

    const [itemCategoryData, setItemCategoryData] = useState<
    ItemCategoryType[]
  >([]);

  const [searchQuery, setSearchQuery] = useSearchParams();
  const searchTerm = searchQuery.get("search") || "";

  const searchCatHandler = (cat: ItemCategoryType, searchTerm: string) => {
    return searchTerm !== ""
      ? new RegExp(`^${searchTerm}|${searchTerm}`, "gi").test(cat.category)
      : true || [];
  };

  const searchHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (!portfolioId) {
      toast("Porfolio required", ToastTypes.ERROR);
      setSearchQuery({ search: "" });
      return;
    }
    setSearchQuery({ search: e.target.value });
  };
  // const [itemDepartmentData, setItemDepartmentData] = useState<ItemDepartmentType[]>([]);
  const limit = 50;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(0);

  useEffect(() => {
    if (ItemCategoryList?.length > 0) {
      setLength(ItemCategoryList?.length ? ItemCategoryList?.length : 0);
    }
  }, [ItemCategoryList]);

    useEffect(()=>{
     navigate("/admin/item_category");
  },[])

  useEffect(() => {
    if (portfolioId) {
      dispatch(fetchDepartment(portfolioId))
      dispatch(fetchItemCategory(portfolioId));
    }
  }, [portfolioId]);

  const getTableData = () => {
    var tableHead: Thead[] = [
      { id: "S.No", children: "S.No", text: "S.No" },
      { id: "Department", children: "Department", text: "Department" },
      { id: "Category", children: "Category", text: "Category" },
      { id: "Status", children: "Status", text: "Status" },
      { id: "Action", children: "Action", text: "Action" },
    ];
    var tableBody: Tbody[][] = [];
    if (portfolioId) {
      itemCategoryData
      .filter((cr) => searchCatHandler(cr, searchTerm))
      .forEach((item, i) => {
        const pageNumber = Math.floor(offset / limit) + 1;
        var tBody: Tbody[] = [];
        let deptIndex = departmentList?.findIndex((a)=>a.depid===item.depid)
        let deptname = departmentList[deptIndex]?.department
        tBody.push(
          {
            id: nanoid(),
            theadId: "S.No",
            children: limit * pageNumber + i - limit + 1,
            text: (limit * pageNumber + i - limit + 1)?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Department",
            children: deptname,
            text: deptname,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Category",
            children: item.category,
            text: item.category,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Status",
            children: item.active ? "Active" : !item.active ? "InActive" : "",
            text: item.active ? "Active" : !item.active ? "InActive" : "",
          },
          {
            id: nanoid(),
            theadId: "Action",
            children: "action",
            className: "d-none",
            text: item.catid?.toString(),
          }
        );
        tableBody.push(tBody);
        // })
      });
    }
    return { tbody: tableBody, thead: tableHead };
  };
  const handleAdd = () => {
    if (!portfolioId) toast("Portfolio required", ToastTypes.ERROR);
    else {
      setShowForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'Create',
          event: `${pageName.pathname.replace("\\", " ")} page | Create Item Category Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleView = () => {
    setFormType(FormTypeList.VIEW);
    if (id !== undefined) {
      var obj = ItemCategoryList.find((c) => c.catid === id);
      setShowForm(true);
      setEditData(obj);
      setShowViewForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'View',
          event: `${pageName.pathname.replace("\\", " ")} page |  ${obj?.depid} Item Category Viewed | View Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handlePfid: ChangeEventHandler<HTMLInputElement> = (e) => {
    setportfolioId(e.target.value);
    setportfolioIdError("");
  };

  const handleDeleteConfirmation = () => {
    setFormType(FormTypeList.DELETE);
    if (id !== undefined) {
      var obj = ItemCategoryList.find((c) => c.catid === id);
      setShowDeleteConfirmation(true);
      const itemSubcategories = ItemSubcategoryList.filter(
        (tsc) => tsc.depid === id
      );
      setDeleteData(obj);
      setDisableDelete((itemSubcategories?.length) ? true : false);
    }
  };

  const handleEdit = () => {
    setFormType(FormTypeList.EDIT);
    if (id !== undefined) {
      var obj = ItemCategoryList.find((c) => c.catid === id);
      setEditData(obj);
      setShowForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'Edit',
          event: `${pageName.pathname.replace("\\", " ")} page | Item Category - ${obj?.category} | Edit Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleDelete: HandleDelete = (value) => {
    if (value.catid !== undefined) {
      let pfId = portfolioId
      let catid = value.catid
      dispatch(deleteItemCategory(pfId, catid))
        .then(async (text) => {
          dispatch(fetchItemCategory(portfolioId));
          toast(text, ToastTypes.SUCCESS);
           if (
            itemCategoryData!== undefined &&
            itemCategoryData?.length === 1
          ) {
            let newOffset = offset - limit < 0 ? 0 : offset - limit;
            setOffset(newOffset);
            await handleApply(newOffset);
          } else {
            await handleApply(); //issue starts from here
          }
          handleFormClose();
        })
        .catch((text) => {});
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setFormType(FormTypeList.ADD);
    setEditData(undefined);
    setId(undefined);
    setShowViewForm(false);
    setShowDeleteConfirmation(false);
  };

  useEffect(() => {
    if (id !== undefined && formType === FormTypeList.VIEW) handleView();
    else if (id !== undefined && formType === FormTypeList.EDIT) handleEdit();
    else if (id !== undefined && formType === FormTypeList.DELETE)
      handleDeleteConfirmation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, formType]);

  useEffect(() => {
    var range = [];
    var num = Math.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range.push(i);
    }

    setRange(range);
  }, [length, limit]);

  useEffect(()=>{
    if(adminAuthendicated){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName.pathname.replace("\\", " ")} page | Visited `
    };
    AdminLog(logProps1)
  }
  },[])

   const handleApply = async (offsetVal = offset) => {
    if (ItemCategoryList?.length > 0) {
      const getData = {
        limit: limit?.toString(),
        offset: offsetVal?.toString(),
      };

      if (
        getData !== undefined &&
        getData.limit !== "" &&
        getData.offset !== "" &&
        getData.offset !== undefined &&
        getData.offset !== "NaN"
      ) {
        const filteredItemCategoryList: ItemCategoryType[] =
          ItemCategoryList?.slice(offset, limit + offset);
        if (filteredItemCategoryList?.length > 0) {
          setItemCategoryData([...filteredItemCategoryList]);
        } else {
          setItemCategoryData([]);
        }
      }
    }
  };

   useEffect(() => {
    handleApply();
  }, [ItemCategoryList]);

  return (
    <>
      <Modal
        headerText={formType + " Item Category"}
        visible={showForm}
        onClose={handleFormClose}
        size="xl"
        centered
      >
        <ItemCategoryForm
          pfId={portfolioId}
          formType={formType}
          editData={editData}
          onSave={handleFormClose}
          showViewForm={showViewForm}
        />
      </Modal>
      <Modal
        headerText={formType + " ITEM CATEGORY"}
        visible={showDeleteConfirmation}
        onClose={handleFormClose}
        size="lg"
        centered
      >
        <DeleteConfirmationForm
          deleteLabel={
            disableDelete
              ? "Item Category is in use. Deletion not allowed."
              : "Do you really want to delete the records with the Item Category - " +
                deleteData?.category
          }
          onCancel={handleFormClose}
          onDelete={() => (disableDelete ? {} : handleDelete(deleteData!))}
        />
      </Modal>
      <AdminLayout>
      <div className="row">
          <div className="col-6 hstack mt-4">
            <label htmlFor="">Portfolio :</label>
            <FormInput
              name="Portfolio"
              label=""
              labelClassName="required"
              value={portfolioId}
              onChange={handlePfid}
              placeholder="Portfolio"
              errorText={portfolioIdError}
              containerClass="w-50"
              disabled={showViewForm}
              type="select"
            >
              <option value="">Select</option>
              {portfolioList.map((a, i) => {
                return (
                  <Option value={a.id} key={i}>
                    {a.name}
                  </Option>
                );
              })}
            </FormInput>
          </div>
        </div>
        <AdminTable2
          addBtnText="Create New Item Category"
          onAdd={handleAdd}
          onEdit={handleEdit}
          onDelete={handleDeleteConfirmation}
          onView={handleView}
          search={searchHandler}
          limit={limit}
          setOffset={setOffset}
          offset={offset}
          onPageNoChange={handleApply}
          range={range}
          pageTitle="Item Category Management"
          path="/admin/item_category"
          setId={setId}
          {...getTableData()}
        />
      </AdminLayout>
    </>
  );
};
export default ItemCategory;
